var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61314 21H8.36064C8.6925 21 8.96252 20.73 8.96252 20.3981V15.6562C8.96252 15.3244 8.6925 15.0544 8.36064 15.0544H6.61127V12.6019H17.4113V15.0544H15.6394C15.3075 15.0544 15.0375 15.3244 15.0375 15.6562V20.3981C15.0375 20.73 15.3075 21 15.6394 21H20.3869C20.7188 21 20.9887 20.73 20.9887 20.3981V15.6562C20.9887 15.3244 20.7188 15.0544 20.3869 15.0544H18.615V12C18.615 11.6681 18.345 11.3981 18.0131 11.3981H12.6131V8.94562H14.385C14.7169 8.94562 14.9869 8.6756 14.9869 8.34374V3.60188C14.9869 3.26999 14.7169 3 14.385 3H9.63749C9.31127 3 9.04124 3.26999 9.04124 3.60188V8.34375C9.04124 8.67561 9.31127 8.94563 9.63749 8.94563H11.415V11.3981H6.01499C5.68314 11.3981 5.41315 11.6681 5.41315 12V15.0544H3.61314C3.28125 15.0544 3.01126 15.3244 3.01126 15.6563V20.3981C3.01126 20.73 3.28125 21 3.61314 21Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkFlow);
export default __webpack_public_path__ + "static/media/WorkFlow.4cdffdc601b9588e8cd673caf86f1220.svg";
export { ForwardRef as ReactComponent };